module.exports = __webpack_public_path__ + "img/notice2.69e5eea7.png";